
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Pipe({
  name: 'translateData'
})

export class TranslateDataPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) {

  }
  transform(data: any, ...args): string {
    var result = args[0];
    var currentLanguage = this.translate.currentLang;

    var titleName = `${args[0]}${currentLanguage[0].toUpperCase()}${currentLanguage[1]}`;
    result = data[titleName];

    return result;
  }


}
